import * as React from 'react';
import TagManager from 'react-gtm-module';
import { connect } from 'react-redux';
import BurgerMenu from './components/BurgerMenu/BurgerMenu';
import ContactUs from './components/ContactUs/ContactUs';
import Dashboard from './components/Dashboard/Dashboard';
import { BrowserRouter } from 'react-router-dom'

import {
    HOME,
    LOGIN,
    RESETPASSWORD,
    REGISTERUSER,
    DASHBOARD,
    PREMIUM_BREAKDOWN,
    PERSONAL_INSURANCE,
    PERSONAL_DETAILS,
    REQUEST_DOCUMENTS,
    CONTACT_US,
    EMERGENCY_ASSISTANCE,
    HOME_CONTENTS,
    MONTHLY_MILEAGE,
    COVER_PORTABLES,
    COVER_MOTORBIKE,
    COVER_CONTENT_BUILDING,
    COVER_CHILLI,
    CAR_COVER,
    POLICY_DETAILS,
    QUOTE_DETAILS,
    LIFE_INSURANCE,
    COVER_WARRANTY,
    COVER_CARAVAN,
    COVER_TRAILER,
    COVER_PERONALACCIDENT,
    COVER_WATERCRAFT,
    IMAGE_PREVIEW,
    CLAIMS,
    ADDCOVER,
    LIFE_INSURANCE_COVER,
    LIFE_INSURANCE_POLICY_DETAILS,
    CLAIMS_HISTORY,
    CLAIMS_DETAILS,
    SUBMIT_CLAIM,
    COVER_BLING,
    SUBMIT_CLAIM_DETAILS,
    SUBMIT_CLAIM_COMPLETE,
    CAR_QUESTION,
    WARRANTY_JOURNEY_BUILDER,
    GET_WARRANTY_QUOTATION,
    CLAIM_HISTORY,
    CAR_REGISTRATION,
    CAR_FINANCE,
    CAR_RISK,
    CAR_TRACKING,
    CART,
    MARITAL_STATUS,
    VEHICLE_LOOKUP,
    REGULAR_DRIVER_OTHER,
    REGULAR_DRIVER,
    QUOTATION,
    INSTALL_TRACKING_DEVICE,
    SALES_ADDRESS,
    DRIVERS_LICENCE,
    CREDIT_HISTORY,
    BANKING_DETAILS,
    LEGAL_STUFF,
    LEGAL_QUESTIONS,
    PERSONAL_INFO,
    PREMIUM,
    ADDRESS,
    GET_CAR_INSURANCE,
    CAR_DETAILS,
    BASE,
    IVERI_SUCCESS,
    SELF_INSPECTION,
    CAPTURE_CAR_DETAILS,
    CAPTURE_IMAGES,
    CAPTURE_CONDITIONS,
    FNOL,
    COMPLETE,
    CLAIMS_IN_THE_MEANTIME,
    IVERI_SUCCESS_CARD,
    GET_LIFE_INSURANCE,
    CLAIM_END_PAGE,
    FNOL_CLAIMS_HISTORY,
    FNOL_SUBMIT_CLAIM,
    FNOL_SUBMIT_CLAIM_COMPLETE,
    FNOL_SUBMIT_CLAIM_DETAILS,
    FNOL_CLAIMS_DETAILS,
    CLAIM_HISTORY_V2,
    CLAIM_INFO,
    BASE_START_PROCESS,
    FNOL_CLAIM_PROGRESS_MOBILE,
    CLAIMSV2_TAKE_PHOTO,
    CLAIMSV2_FEEDBACK,
    PORTABLE_POSSESSIONS,
    GET_PORTABLE_POSSESSIONS_INSURANCE,
    ADD_REPLACEMENT_VALUE,
    PORTABLE_POSSESSIONS_RISK,
    PORTABLE_POSSESSIONS_CLAIM_HISTORY,
    DESCRIBE_POSSESSION,
    GET_BLING_INSURANCE,
    GATHER_INFO,
    REGULAR_CELLPHONE_REGISTRATION_NUMBER,
    CELLPHONE_DETAILS,
    COVER_OPTIONS,
    CELLPHONE_CASE,
    GET_CODE_RED_INSURANCE,
    CODE_RED_VIEW_BUILDER,
    AGREED_VALUE_SELECT,
    GUESTUSERLOGIN,
    GUESTSIGNUP,
    GUESTQUOTE,
    BUILDING_AND_CONTENT_JOURNEY_BUILDER,
    GET_BUILDING_QUOTATION,
    GET_HOME_CONTENT_QUOTATION,
    PAYMENT_INITIALIZE,
    PAYMENT_SUCCESS,
    PAYMENT_FAILURE,
    MOBILE_AUTH, MOBILE_APP_LOGIN,
} from './routes/routes';

import RedirectPortal from './components/RedirectPortal';
import GuestLogin from './components/Guest/GuestLogin';
import GuestSignup from './components/Guest/GuestSignup';
import GuestQuote from './components/Guest/GuestQuote';
import EmergencyAssist from './components/EmergencyAssist/EmergencyAssist';
import HomeContents from './components/HomeContents/HomeContents';
import LifeInsurance from './components/LifeInsurance/LifeInsurance';
import LoadingScreen from './components/LoadingScreens/LoadingScreen';
import SalesChatLoadingScreen from './components/LoadingScreens/SalesChatLoadingScreen';
import QuoteLoadingScreen from './components/LoadingScreens/QuoteLoadingScreen';
import PolicyViewSuccessScreen from './components/LoadingScreens/PolicyViewSuccessScreen';
import PolicyLoadViewScreen from './components/LoadingScreens/PolicyLoadViewScreen';
import MaintenanceScreen from './components/MaintenanceScreen/MaintenanceScreen';
import MonthlyMileageDashboard from './components/MonthlyMileage/MonthlyMileageDashboard';
import PersonalDetails from './components/PersonalDetails/PersonalDetails';
import PersonalInsurance from './components/PersonalInsurance/PersonalInsurance';
import PolicyDetails from './components/PersonalInsurance/PolicyDetails/PolicyDetails';
import PolicyDetailsCar from './components/PersonalInsurance/PolicyDetails/PolicyDetailsCar';
import PolicyDetailsChilli from './components/PersonalInsurance/PolicyDetails/PolicyDetailsChilli';
import PolicyDetailsContentBuilding from './components/PersonalInsurance/PolicyDetails/PolicyDetailsContentBuilding';
import PolicyDetailsMotorbike from './components/PersonalInsurance/PolicyDetails/PolicyDetailsMotorbike';
import PolicyDetailsPortables from './components/PersonalInsurance/PolicyDetails/PolicyDetailsPortables';
import PolicyDetailsWarranty from './components/PersonalInsurance/PolicyDetails/PolicyDetailsWarranty';
import PolicyDetailsCaravan from './components/PersonalInsurance/PolicyDetails/PolicyDetailsCaravan';
import PolicyDetailsPersonalAccident from './components/PersonalInsurance/PolicyDetails/PolicyDetailsPersonalAccident';
import PolicyDetailsWatercraft from './components/PersonalInsurance/PolicyDetails/PolicyDetailsWatercraft';
import PremiumBreakdown from './components/PremiumBreakdown/PremiumBreakdown';
import Claims from './components/Claims/Claims';
import Fnol from './components/FNOL/Claims';
import Profile from './components/Profile/Profile';
import RegisterPage from './components/RegisterPage/RegisterPage';
import RequestDocuments from './components/RequestDocuments/RequestDocuments';
import ResetPassword from './components/ResetPassword/ResetPassword';
import SignIn from './components/SignIn/SignInPage';
import TopNav from './components/TopNav/TopNav';
import './custom.css';
import './cic-chat-kp.css';
import SecureRoute from './routes/SecureRoute';
import NonSecureRoute from './routes/NonSecureRoute';
import PolicyDetailsTrailer from './components/PersonalInsurance/PolicyDetails/PolicyDetailsTrailer';
import PhotoSteps from './components/PhotoSteps/PhotoSteps';
import SelfInspectSteps from './components/SelfInspection/SelfInspectSteps/SelfInspectSteps';
import FullscreenCamera from './components/Camera/FullscreenCamera';
import ImagePreview from './components/Camera/ImagePreview';
import GetCover from './components/GetCover/GetCover';
import { hideLoadingScreen, hideMaintenanceScreen } from './actions/fullscreenActions';
import { signOut } from './actions/authActions';
import LifeInsuranceCover from './components/LifeInsurance/LifeInsuranceCover';
import LifeInsurancePolicyDetails from './components/LifeInsurance/LifeInsurancePolicyDetails';
import SubmitClaim from './components/Claims/SubmitClaim';
import ClaimsInfo from './components/Claims/ClaimsHistory/ClaimInfo';
import ClaimsInfoV2 from './components/Claims/ClaimsHistoryV2/ClaimInfo';
import ClaimsHistory from './components/Claims/ClaimsHistory/ClaimsHistory';
import ClaimsHistoryV2 from './components/Claims/ClaimsHistoryV2/ClaimsHistory';
import ClaimDetails from './components/Claims/ClaimDetails';
import ClaimComplete from './components/Claims/ClaimComplete';
import FNOLSubmitClaim from './components/FNOL/SubmitClaim';
import FNOLClaimsInfo from './components/FNOL/ClaimsHistory/ClaimInfo';
import FNOLClaimsHistory from './components/FNOL/ClaimsHistory/ClaimsHistory';
import FNOLClaimDetails from './components/FNOL/ClaimDetails';
import FNOLClaimComplete from './components/FNOL/ClaimComplete';
import ClaimInMeantime from './components/FNOL/ClaimInMeantime';
import MobileClaimProgress from './components/FNOL/MobileClaimProgress';
import FNOLPhotoCover from './components/FNOL/TakePhotos/FNOLPhotoCover';
import ClaimsV2PhotoCover from './components/Claims/TakePhotosV2/ClaimsV2PhotoCover';
import { Helmet } from 'react-helmet'
import { logErrorToDatabase, logWarningToDatabase } from './actions/apiActions';
import PolicyDetailsBlingNew from './components/PersonalInsurance/PolicyDetails/PolicyDetailsBlingNew';
import ErrorBoundary from './components/ErrorBoundaries/ErrorBoundary';
import { setApplicationId, setAppVersionMain, setCountry, setIsLivinEnabled, setSettings } from './actions/sspActions';
import CarRegistration from './components/OnlineQuotation/CarRegistration/CarRegistration';
import CarFinance from './components/OnlineQuotation/CarFinance/CarFinance';
import CarDetails from './components/OnlineQuotation/CarDetails/CarDetails';
import CarQuestion from './components/OnlineQuotation/CarQuestion/CarQuestion';
import CarRisk from './components/OnlineQuotation/CarRisk/CarRisk';
import Cart from './components/OnlineQuotation/Cart/Cart';
import CarTracking from './components/OnlineQuotation/CarTracking/CarTracking';
import ClaimHistory from './components/OnlineQuotation/ClaimHistory/ClaimHistory';
import DriversLicence from './components/OnlineQuotation/DriversLicence/DriversLicence';
import InstallTrackingDevice from './components/OnlineQuotation/InstallTrackingDevice/InstallTrackingDevice';
import MaritalStatus from './components/OnlineQuotation/MaritalStatus/MaritalStatus';
import SalesAddress from './components/OnlineQuotation/SalesAddress/SalesAddress';
import QuotationSelector from './components/OnlineQuotation/QuotationSelector/QuotationSelector';
import RegularDriver from './components/OnlineQuotation/RegularDriver/RegularDriver';
import RegularDriverOther from './components/OnlineQuotation/RegularDriverOther/RegularDriverOther';
import VehicleLookup from './components/OnlineQuotation/VehicleLookup/VehicleLookup';
import WarrantyJourneyBuilder from './components/OnlineQuotation/Warranty/WarrantyJourneyBuilder/WarrantyJourneyBuilder';
import GetWarrantyInsurance from './components/OnlineQuotation/Warranty/GetWarranty/GetWarranty';
import Address from './components/OnlineQuotation/Address/Address';
import BankingDetails from './components/OnlineQuotation/BankingDetails/BankingDetails';
import CreditHistory from './components/OnlineQuotation/CreditHistory/CreditHistory';
import LegalQuestions from './components/OnlineQuotation/LegalStuff/LegalQuestions'
import PersonalInfo from './components/OnlineQuotation/PersonalInfo/PersonalInfo';
import Premium from './components/OnlineQuotation/Premium/Premium';
import GetCarInsurance from './components/OnlineQuotation/GetCarInsurance/GetCarInsurance';

/*Portal Possessions*/
import PortablePossessions from './components/OnlineQuotation/PortablePossessions/AddPortablePossessions';
import GetPortablePossessionsInsurance from './components/OnlineQuotation/PortablePossessions/GetPortablePossessionsInsurance';
import AddReplacementValue from './components/OnlineQuotation/PortablePossessions/AddReplacementValue';
import DescribePossession from './components/OnlineQuotation/PortablePossessions/DescribePossession';

import PortablePossesionsRisk from './components/OnlineQuotation/PortablePossessions/PortablePossesionsRisk';
import PortablePossessionsClaimHistory from './components/OnlineQuotation/PortablePossessions/PortablePossessionsClaimHistory';

import IveriSuccess from './components/Iveri/IveriSuccess';
import Loader from './components/LoadingScreens/Loader';
import LoaderSuccess from './components/LoadingScreens/LoaderSuccess';
import IveriSuccessLoadingScreen from './components/LoadingScreens/IveriSuccessLoadingScreen';

import SelfInspection from './components/SelfInspection/LandingPage/SelfInspection';
import CaptureImages from './components/SelfInspection/CaptureImages/CaptureImages';
import CaptureCarDetails from './components/SelfInspection/CaptureCarDetails/CaptureCarDetails';
import CaptureConditions from './components/SelfInspection/CaptureConditions/CaptureConditions';
import Complete from './components/SelfInspection/Complete/Complete';
import IveriSuccessChangeCard from './components/Iveri/IveriSuccessChangeCard';
import GetLifeInsurance from "./components/LifeInsurance/GetLifeInsurance";
import ClaimEndPage from './components/FNOL/ClaimEndPage';

import ClaimsV2Step6 from './components/Claims/ClaimsV2Steps/ClaimsV2Step6TakePhoto'

import ClaimsFeedback from './components/Claims/ClaimsHistoryV2/ClaimsFeedback'

//Base Template steps
import StartProcess from './components/BaseTemplate/StartProcess';

//Bling
import GetBlingInsurance from './components/OnlineQuotation/Bling/GetBlingInsurance';
import GatherInfo from './components/OnlineQuotation/Bling/GatherInfo';
import CellphoneDetails from './components/OnlineQuotation/Bling/CellphoneDetails';
import CellphoneRegistrationNumber from './components/OnlineQuotation/Bling/CellphoneRegistrationNumber';
import CoverOptions from './components/OnlineQuotation/Bling/CoverOptions';
import CellphoneCase from './components/OnlineQuotation/Bling/CellphoneCase'
import { SA_COUNTRY_ID } from './constants/internationalization';

//Code Red
import GetCodeRedInsurance from './components/OnlineQuotation/CodeRed/GetCodeRed';
import CodeRedViewBuilder from './components/OnlineQuotation/CodeRed/CodeRedSales';

//Agreed Value
import SwapAgreedValuePage from './components/OnlineQuotation/AgreedValue/SwapAgreedValue/SwapAgreedValuePage';

//Building and Content
import GetBuildingInsurance from './components/OnlineQuotation/BuildingAndContent/GetBuilding/GetBuilding';
import GetHomeContentInsurance from './components/OnlineQuotation/BuildingAndContent/GetHomeContent/GetHomeContent';
import GetBuildingAndContentInsurance from './components/OnlineQuotation/BuildingAndContent/JourneyBuilder/JourneyBuilder';

//Payments
import PaymentInitialize from './components/Payments/PayAt/PaymentInitialize';
import PaymentSuccess from './components/Payments/PayAt/PaymentSuccess';
import PaymentFailure from './components/Payments/PayAt/PaymentFailure';
import QuoteDetails from './components/PersonalInsurance/QuoteDetails/QuoteDetails';

//AutoLogin and redirects
import MobileAuthSelfInspect from './components/Mobile/MobileAuth';
import MobileAutoLogin from "./components/Mobile/MobileAutoLogin";

const tagManagerArgs = {
    gtmId: 'GTM-MVK75B'
}

export const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

var console = (function (oldCons) {
    return {
        log: function (text) {
            if (isLocalhost) {
                oldCons.log(text);
            }
        },
        info: function (text) {
            if (isLocalhost) {
                oldCons.info(text);
            }
        },
        warn: function (text) {
            if (isLocalhost) {
                oldCons.warn(text);
            }
            if (text.includes("UNSAFE_") !== true) {
                logWarningToDatabase(text);
            }
        },
        error: function (text) {
            if (isLocalhost) {
                oldCons.error(text);
            }
            logErrorToDatabase(text);
        }
    };
}(window.console));

try {
    TagManager.initialize(tagManagerArgs)
} catch (err) {
    logErrorToDatabase("Error initializing TagManager: " + err);
}

// @ts-ignore
window.console = console;

class App extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = { startup: true };
        this.refreshCache = this.refreshCache.bind(this);
    }

    async refreshCache() {
        await this.props.dispatchAction(signOut(false));
        if (caches !== undefined && caches) {
            caches.keys().then(function (names) {
                for (let name of names) caches.delete(name);
            });
        }
        if (this.props.ssp.reloadOnUnmount) {
            window.location.reload();
        }
    }

    semverGreaterThan(versionA, versionB) {
        const versionsA = versionA.split(/\./g);
        const versionsB = versionB.split(/\./g);
        while (versionsA.length || versionsB.length) {
            const a = Number(versionsA.shift());
            const b = Number(versionsB.shift());
            if (a === b) continue;
            return a > b || isNaN(b);
        }
        return false;
    };

    async componentDidMount() {
        await window.addEventListener('beforeunload', this.refreshCache, { once: true });
        await setAppVersionMain();
        await setApplicationId();
        await setIsLivinEnabled();
        await setSettings();
        await setCountry();
        this.setState({ startup: false });
    }

    async componentWillUnmount() {
        await this.refreshCache();
        await window.removeEventListener('beforeunload', this.refreshCache);
    }

    render(): JSX.Element {
        let redirectRoutes = <>
            <NonSecureRoute path='*' component={RedirectPortal} loginSensitive={false} />
        </>;

        let paymentRoutes = <>
            <NonSecureRoute exact path={PAYMENT_INITIALIZE} component={PaymentInitialize} loginSensitive={false} />
            <NonSecureRoute exact path={PAYMENT_SUCCESS} component={PaymentSuccess} loginSensitive={false} />
            <NonSecureRoute exact path={PAYMENT_FAILURE} component={PaymentFailure} loginSensitive={false} />
        </>;

        let iveriRoutes = <>
            <NonSecureRoute exact path={BASE + IVERI_SUCCESS} component={IveriSuccess} loginSensitive={false} />
            <NonSecureRoute exact path={BASE + IVERI_SUCCESS_CARD} component={IveriSuccessChangeCard} loginSensitive={false} />
        </>;

        let nonSecureRoutes = <>
            <NonSecureRoute exact path={HOME} component={SignIn} loginSensitive={false} />
            <NonSecureRoute exact path={LOGIN} component={SignIn} loginSensitive={false} />
            <NonSecureRoute exact path={RESETPASSWORD} component={ResetPassword} loginSensitive={false} />
            <NonSecureRoute exact path={REGISTERUSER} component={RegisterPage} loginSensitive={false} />
            <NonSecureRoute exact path={GUESTUSERLOGIN} component={GuestLogin} loginSensitive={false} />
            <NonSecureRoute exact path={GUESTQUOTE} component={GuestQuote} loginSensitive={false} />
            <NonSecureRoute exact path={MOBILE_AUTH} component={MobileAuthSelfInspect} loginSensitive={false} />
            <NonSecureRoute exact path={MOBILE_APP_LOGIN} component={MobileAutoLogin} loginSensitive={false} />
        </>;

        let routes = <>
            <SecureRoute exact path={DASHBOARD} component={Dashboard} />
            <SecureRoute exact path={PREMIUM_BREAKDOWN} component={PremiumBreakdown} />
            {!this.props.ssp?.livinEnabled &&
                <SecureRoute exact path={PERSONAL_DETAILS} component={PersonalDetails} />
                ||
                // We have nested routes here for life, still need to render if not exact
                <SecureRoute path={PERSONAL_DETAILS} component={PersonalDetails} />
            }
            <SecureRoute exact path={REQUEST_DOCUMENTS} component={RequestDocuments} />
            <SecureRoute exact path={CONTACT_US} component={ContactUs} />
            <SecureRoute exact path={EMERGENCY_ASSISTANCE} component={EmergencyAssist} />
            <SecureRoute exact path={MONTHLY_MILEAGE} component={MonthlyMileageDashboard} />
            <SecureRoute exact path={SELF_INSPECTION} component={SelfInspection} />
            <SecureRoute exact path={HOME_CONTENTS} component={HomeContents} />
            <SecureRoute exact path={PERSONAL_INSURANCE} component={PersonalInsurance} />
            <SecureRoute exact path={POLICY_DETAILS} component={PolicyDetails} />
            <SecureRoute exact path={QUOTE_DETAILS} component={QuoteDetails} />
            <SecureRoute exact path={CAR_COVER} component={PolicyDetailsCar} />
            <SecureRoute exact path={COVER_CHILLI} component={PolicyDetailsChilli} />
            <SecureRoute exact path={COVER_CONTENT_BUILDING} component={PolicyDetailsContentBuilding} />
            <SecureRoute exact path={COVER_PORTABLES} component={PolicyDetailsPortables} />
            <SecureRoute exact path={COVER_MOTORBIKE} component={PolicyDetailsMotorbike} />
            <SecureRoute exact path={COVER_CARAVAN} component={PolicyDetailsCaravan} />
            <SecureRoute exact path={COVER_PERONALACCIDENT} component={PolicyDetailsPersonalAccident} />
            <SecureRoute exact path={COVER_WATERCRAFT} component={PolicyDetailsWatercraft} />
            <SecureRoute exact path={COVER_WARRANTY} component={PolicyDetailsWarranty} />
            <SecureRoute exact path={COVER_TRAILER} component={PolicyDetailsTrailer} />
            <SecureRoute exact path={COVER_BLING} component={PolicyDetailsBlingNew} />
            <SecureRoute exact path={CODE_RED_VIEW_BUILDER} component={CodeRedViewBuilder} />
            <SecureRoute exact path={IMAGE_PREVIEW} component={ImagePreview} />
            <SecureRoute exact path={CLAIMS} component={Claims} />
            <SecureRoute exact path={FNOL} component={Fnol} />
            <SecureRoute exact path={SUBMIT_CLAIM} component={SubmitClaim} />
            <SecureRoute exact path={FNOL_SUBMIT_CLAIM} component={FNOLSubmitClaim} />
            <SecureRoute exact path={ADDCOVER} component={GetCover} />
            <SecureRoute path={LIFE_INSURANCE} component={LifeInsurance} />
            <SecureRoute exact path={LIFE_INSURANCE_POLICY_DETAILS} component={LifeInsurancePolicyDetails} />
            <SecureRoute exact path={LIFE_INSURANCE_COVER} component={LifeInsuranceCover} />
            <SecureRoute exact path={CLAIMS_HISTORY} component={ClaimsHistory} />
            <SecureRoute exact path={FNOL_CLAIMS_HISTORY} component={FNOLClaimsHistory} />
            <SecureRoute exact path={CLAIMS_DETAILS} component={ClaimsInfo} />
            <SecureRoute exact path={FNOL_CLAIMS_DETAILS} component={FNOLClaimsInfo} />
            <SecureRoute exact path={SUBMIT_CLAIM_DETAILS} component={ClaimDetails} />
            <SecureRoute exact path={FNOL_SUBMIT_CLAIM_DETAILS} component={FNOLClaimDetails} />
            <SecureRoute exact path={FNOL_CLAIM_PROGRESS_MOBILE} component={MobileClaimProgress} />
            <SecureRoute exact path={SUBMIT_CLAIM_COMPLETE} component={ClaimComplete} />
            <SecureRoute exact path={FNOL_SUBMIT_CLAIM_COMPLETE} component={FNOLClaimComplete} />
            <SecureRoute exact path={CLAIMS_IN_THE_MEANTIME} component={ClaimInMeantime} />
            <SecureRoute exact path={CAPTURE_CAR_DETAILS} component={CaptureCarDetails} />
            <SecureRoute exact path={CAPTURE_IMAGES} component={CaptureImages} />
            <SecureRoute exact path={CAPTURE_CONDITIONS} component={CaptureConditions} />
            <SecureRoute exact path={COMPLETE} component={Complete} />
            <SecureRoute exact path={CLAIM_END_PAGE} component={ClaimEndPage} />
            <SecureRoute exact path={CLAIM_HISTORY_V2} component={ClaimsHistoryV2} />
            <SecureRoute exact path={CLAIM_INFO} component={ClaimsInfoV2} />
            <SecureRoute exact path={CLAIMSV2_TAKE_PHOTO} component={ClaimsV2Step6} />
            <SecureRoute exact path={CLAIMSV2_FEEDBACK} component={ClaimsFeedback} />
            <SecureRoute exact path={CELLPHONE_CASE} component={CellphoneCase} />
            <SecureRoute exact path={PORTABLE_POSSESSIONS} component={PortablePossessions} />
            <SecureRoute exact path={GET_CAR_INSURANCE} component={GetCarInsurance} />
            <SecureRoute exact path={GET_CODE_RED_INSURANCE} component={GetCodeRedInsurance} />
            <SecureRoute exact path={GET_LIFE_INSURANCE} component={GetLifeInsurance} />
            <SecureRoute exact path={GET_PORTABLE_POSSESSIONS_INSURANCE} component={GetPortablePossessionsInsurance} />
            <SecureRoute exact path={GET_BLING_INSURANCE} component={GetBlingInsurance} />
            <SecureRoute exact path={CAR_QUESTION} component={CarQuestion} />
            <SecureRoute exact path={CAR_REGISTRATION} component={CarRegistration} />
            <SecureRoute exact path={CAR_FINANCE} component={CarFinance} />
            <SecureRoute exact path={CAR_DETAILS} component={CarDetails} />
            <SecureRoute exact path={CAR_RISK} component={CarRisk} />
            <SecureRoute exact path={CART} component={Cart} />
            <SecureRoute exact path={CAR_TRACKING} component={CarTracking} />
            <SecureRoute exact path={CLAIM_HISTORY} component={ClaimHistory} />
            <SecureRoute exact path={DRIVERS_LICENCE} component={DriversLicence} />
            <SecureRoute exact path={INSTALL_TRACKING_DEVICE} component={InstallTrackingDevice} />
            <SecureRoute exact path={MARITAL_STATUS} component={MaritalStatus} />
            <SecureRoute exact path={SALES_ADDRESS} component={SalesAddress} />
            <SecureRoute exact path={QUOTATION} component={QuotationSelector} />
            <SecureRoute exact path={REGULAR_DRIVER} component={RegularDriver} />
            <SecureRoute exact path={REGULAR_DRIVER_OTHER} component={RegularDriverOther} />
            <SecureRoute exact path={VEHICLE_LOOKUP} component={VehicleLookup} />
            <SecureRoute exact path={GET_WARRANTY_QUOTATION} component={GetWarrantyInsurance} />
            <SecureRoute exact path={WARRANTY_JOURNEY_BUILDER} component={WarrantyJourneyBuilder} />
            <SecureRoute exact path={GET_BUILDING_QUOTATION} component={GetBuildingInsurance} />
            <SecureRoute exact path={GET_HOME_CONTENT_QUOTATION} component={GetHomeContentInsurance} />
            <SecureRoute exact path={BUILDING_AND_CONTENT_JOURNEY_BUILDER} component={GetBuildingAndContentInsurance} />
            <SecureRoute exact path={ADDRESS} component={Address} />
            <SecureRoute exact path={CREDIT_HISTORY} component={CreditHistory} />
            <SecureRoute exact path={PERSONAL_INFO} component={PersonalInfo} />
            <SecureRoute exact path={PREMIUM} component={Premium} />
            <SecureRoute exact path={BANKING_DETAILS} component={BankingDetails} />
            <SecureRoute exact path={LEGAL_STUFF} component={LegalQuestions} />
            <SecureRoute exact path={LEGAL_QUESTIONS} component={LegalQuestions} />
            <SecureRoute exact path={BASE_START_PROCESS} component={StartProcess} />
            <SecureRoute exact path={ADD_REPLACEMENT_VALUE} component={AddReplacementValue} />
            <SecureRoute exact path={DESCRIBE_POSSESSION} component={DescribePossession} />
            <SecureRoute exact path={PORTABLE_POSSESSIONS_RISK} component={PortablePossesionsRisk} />
            <SecureRoute exact path={PORTABLE_POSSESSIONS_CLAIM_HISTORY} component={PortablePossessionsClaimHistory} />
            <SecureRoute exact path={GATHER_INFO} component={GatherInfo} />
            <SecureRoute exact path={CELLPHONE_DETAILS} component={CellphoneDetails} />
            <SecureRoute exact path={REGULAR_CELLPHONE_REGISTRATION_NUMBER} component={CellphoneRegistrationNumber} />
            <SecureRoute exact path={COVER_OPTIONS} component={CoverOptions} />
            <SecureRoute exact path={AGREED_VALUE_SELECT} component={SwapAgreedValuePage} />
            <SecureRoute exact path={GUESTSIGNUP} component={GuestSignup} />
        </>;

        let menu = <></>;

        if (this.props.firebaseAuth.uid !== undefined && (this.props.auth?.provider ?? "") !== "anonredirect") {
            menu = <>
                <ErrorBoundary>
                    <Profile />
                </ErrorBoundary>
                <ErrorBoundary>
                    <BurgerMenu />
                </ErrorBoundary>
            </>;
        }

        let helmet = <Helmet>
            <title>King Price - Self Service Portal</title>
            <script src="https://apps.mypurecloud.com/pureconnect-widgets" pureconnect-widgets-data="eyJpZCI6IkNsaWVudENhcmVDaGF0IiwiaWNTZXJ2ZXJzIjpbIndlYmNoYXQua2luZ3ByaWNlLmNvLnphIl0sInJldmVyc2VQcm94eVVybCI6bnVsbCwidXNlQ2FhUyI6ZmFsc2UsImNhYXNVcmwiOm51bGwsInVzZUh0dHBzIjp0cnVlfQ==" />
        </Helmet>;

        if (this.state.startup) {
            return (
                <ErrorBoundary>
                    {!isLocalhost && this.props.profile.countryId === SA_COUNTRY_ID &&
                        {helmet}
                    }
                    <LoadingScreen isLoading={true} />
                </ErrorBoundary>
            );
        }

        if (this.props.ssp.paymentPortalOnly) {
            return (
                <ErrorBoundary>
                    {!isLocalhost && this.props.profile.countryId === SA_COUNTRY_ID &&
                        {helmet}
                    }
                    <div style={{ display: this.props.fullscreen.loadingScreenVisible ? 'block' : 'none' }}>
                        <LoadingScreen isLoading={true} />
                    </div>
                    <div style={{ display: this.props.fullscreen.maintenanceScreenVisible ? 'block' : 'none' }}>
                        <MaintenanceScreen />
                    </div>
                    <div>
                        <TopNav static={true} />
                        <div id="mainContent" style={{
                            display: (this.props.fullscreen.loadingScreenVisible || this.props.fullscreen.maintenanceScreenVisible) ? 'none' : 'block',
                        }}>
                            <div id="baseApp">
                                <main>
                                    <section className="grey-bg">
                                        <switch>
                                            {paymentRoutes}
                                            {redirectRoutes}
                                            {this.props.children}
                                        </switch>
                                    </section>
                                </main>
                            </div>
                        </div>
                    </div>
                </ErrorBoundary>
            );
        }

        return (
            <>
                <ErrorBoundary>
                    {!isLocalhost && this.props.profile.countryId === SA_COUNTRY_ID &&
                        {helmet}
                    }
                    <div style={{ display: this.props.fullscreen.loadingScreenVisible ? 'block' : 'none' }}>
                        <LoadingScreen isLoading={true} />
                    </div>
                    <div style={{ display: this.props.fullscreen.salesChatLoadingScreenVisible ? 'block' : 'none' }}>
                        <SalesChatLoadingScreen isLoading={true} />
                    </div>
                    <div style={{ display: this.props.fullscreen.policyViewSuccessScreenVisible ? 'block' : 'none' }}>
                        <PolicyViewSuccessScreen isLoading={true} />
                    </div>
                    <div style={{ display: this.props.fullscreen.policyLoadViewScreenVisible ? 'block' : 'none' }}>
                        <PolicyLoadViewScreen isLoading={true} />
                    </div>
                    <div style={{ display: this.props.fullscreen.updatePolicyLoadViewVisible ? 'block' : 'none' }}>
                        <Loader isLoading={true} />
                    </div>
                    <div style={{ display: this.props.fullscreen.updatePolicySuccessLoadVisible ? 'block' : 'none' }}>
                        <LoaderSuccess isLoading={true} />
                    </div>
                    <div style={{ display: this.props.fullscreen.iveriSuccessVisible ? 'block' : 'none' }}>
                        <IveriSuccessLoadingScreen isLoading={true} />
                    </div>
                    <div style={{ display: this.props.fullscreen.quoteLoadingScreenVisible ? 'block' : 'none' }}>
                        <QuoteLoadingScreen isLoading={true} />
                    </div>
                    <div style={{ display: this.props.fullscreen.inspectionPhotoStepVisible ? 'block' : 'none' }}>
                        <PhotoSteps />
                    </div>
                    <div style={{ display: this.props.fullscreen.fnolTakePhotoVisible ? 'block' : 'none' }}>
                        <FNOLPhotoCover />
                    </div>
                    <div style={{ display: this.props.fullscreen.claimsV2TakePhotoVisible ? 'block' : 'none' }}>
                        <ClaimsV2PhotoCover />
                    </div>
                    <div style={{ display: this.props.fullscreen.fullscreenCameraVisible ? 'block' : 'none' }}>
                        <FullscreenCamera />
                    </div>
                    <div style={{ display: this.props.fullscreen.maintenanceScreenVisible ? 'block' : 'none' }}>
                        <MaintenanceScreen />
                    </div>
                    <div style={{ display: this.props.fullscreen.selfInspectStepsVisible ? 'block' : 'none' }}>
                        <SelfInspectSteps />
                    </div>
                    <div>
                        <ErrorBoundary>
                            <BrowserRouter>
                                <TopNav />
                            </BrowserRouter>
                        </ErrorBoundary>
                        <div id="mainContent" style={{
                            display: (this.props.fullscreen.loadingScreenVisible ||
                                this.props.fullscreen.inspectionPhotoStepVisible ||
                                this.props.fullscreen.maintenanceScreenVisible ||
                                this.props.fullscreen.fullscreenCameraVisible) ? 'none' : 'block',
                        }}>
                            <div id="baseApp">
                                <main>
                                    <BrowserRouter>
                                        {menu}
                                    </BrowserRouter>

                                    <section className="grey-bg">
                                        <switch>
                                            {iveriRoutes}
                                            {paymentRoutes}
                                            {this.props.children}
                                            {nonSecureRoutes}
                                            <div id='appContainer' className={this.props.profile.showMobileProfile ? "showProfile" : "noProfile"}>
                                                {routes}
                                            </div>
                                        </switch>
                                    </section>
                                </main>
                            </div>
                        </div>
                    </div>
                </ErrorBoundary>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebaseAuth: state.firebase.auth,
        auth: state.auth,
        fullscreen: state.fullscreen,
        redirect: state.redirect,
        profile: state.profile,
        ssp: state.ssp,
        lifePolicy: state.lifePolicy,
        navigation: state.navigation
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHideLoadingScreen: () => dispatch(hideLoadingScreen()),
        dispatchHideMaintenanceScreen: () => dispatch(hideMaintenanceScreen()),
        dispatchAction: (e) => dispatch(e),
    }
}

const rootElement = document.getElementById("root");
export default connect(mapStateToProps, mapDispatchToProps)(App, rootElement)